export type StatusSeverity = 'error' | 'warning' | 'success';

export interface StatusConfig {
  severity: StatusSeverity;
  isWarning: boolean;
}

export function getLeakedConfig(value: string): StatusConfig {
  const isLeaked = value.toLowerCase().includes('yes');
  return {
    severity: isLeaked ? 'error' : 'success',
    isWarning: isLeaked,
  };
}

export function getActivityConfig(value: string): StatusConfig {
  const normalized = value.toLowerCase();
  if (normalized.includes('high')) {
    return { severity: 'error', isWarning: true };
  }
  if (normalized.includes('medium')) {
    return { severity: 'warning', isWarning: true };
  }
  return { severity: 'success', isWarning: false };
}

export function getDncConfig(value: string): StatusConfig {
  const isNotOnList = value.toLowerCase().includes('not');
  return {
    severity: isNotOnList ? 'success' : 'error',
    isWarning: !isNotOnList,
  };
}

export function getInitials(name: string): string {
  return name
    .split(' ')
    .filter((word) => word.length > 0)
    .map((word) => word[0] ?? '')
    .join('')
    .toUpperCase()
    .slice(0, 2);
}
